import React from 'react';
import { Row, Col, InputGroup } from 'react-bootstrap';
import Select from "react-dropdown-select";
import styled from 'styled-components';
import SortIcon from '@mui/icons-material/Sort';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import ViewListIcon from '@mui/icons-material/ViewList';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewComfyIcon from '@mui/icons-material/ViewComfy';

function SceneSort(props) {
    const viewOptions = [
        { key: 'list', value: 'List View', icon: ViewListIcon },
        { key: 'card-full', value: 'Card (Full)', icon: GridViewIcon },
        { key: 'card-minimal', value: 'Card (Minimal)', icon: ViewComfyIcon }
    ];

    return (
        <CompactSortContainer>
            <CompactSortGroup>
                <SortTooltip title="Sort By">
                    <SortIcon fontSize="small" />
                </SortTooltip>
                <SortBySelect 
                    options={props.filters[0].items} 
                    labelField="value" 
                    valueField="key" 
                    sortBy="value" 
                    values={[props.filters[0].items.find(a => a.key === props.filters[0].selected)]}
                    onChange={(e) => {
                        props.filterRefresh(props.filters[0].key, e[0].key, props.params.direction)
                    }}
                />
            </CompactSortGroup>

            <CompactSortGroup>
                <SortTooltip title="Order">
                    <SwapVertIcon fontSize="small" />
                </SortTooltip>
                <CompactStyledSelect 
                    options={props.filters[1].items} 
                    labelField="value" 
                    valueField="key" 
                    sortBy="value" 
                    values={[props.filters[1].items.find(a => a.key === props.filters[1].selected)]}
                    onChange={(e) => {
                        props.filterRefresh(props.filters[1].key, props.params.sort, e[0]?.key)
                    }}
                />
            </CompactSortGroup>

            <CompactSortGroup>
                <SortTooltip title="Per Page">
                    <ViewWeekIcon fontSize="small" />
                </SortTooltip>
                <CompactStyledSelect 
                    options={props.filters[2].items} 
                    labelField="value" 
                    create="true" 
                    valueField="key" 
                    sortBy="value" 
                    values={[props.filters[2].items.find(a => a.key === props.filters[2]?.selected)]} 
                    onChange={(e) => {
                        props.sizeRefresh(e[0].key)
                    }}
                />
            </CompactSortGroup>

            <ViewSeparator />

            <ViewGroup>
                {viewOptions.map((option) => {
                    const IconComponent = option.icon;
                    return (
                        <ViewButton
                            key={option.key}
                            isActive={props.viewType === option.key}
                            onClick={() => props.setViewType(option.key)}
                            title={option.value}
                        >
                            <IconComponent fontSize="small" />
                        </ViewButton>
                    );
                })}
            </ViewGroup>
        </CompactSortContainer>
    );
}

const CompactSortContainer = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: flex-end;
  background: transparent;
  padding: 0;
`;

const CompactSortGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 0 1 auto;
`;

const SortTooltip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  min-width: 24px;
  height: 32px;
  background: rgba(102, 126, 234, 0.08);
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: help;
  font-size: 12px;
  font-weight: 600;

  svg {
    font-size: 18px;
  }

  &:hover {
    background: rgba(102, 126, 234, 0.15);
    color: #764ba2;
  }
`;

const CompactStyledSelect = styled(Select)`
  .react-dropdown-select {
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    background-color: #ffffff;
    transition: all 0.2s ease;
    padding: 4px 6px;
    min-height: auto;
    min-width: 150px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

    &:hover {
      border-color: #667eea;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.12);
    }

    &:focus-within {
      border-color: #667eea;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    }

    .react-dropdown-select-input {
      font-size: 12px;
      color: #333;
      padding: 4px 0;
      min-height: 18px;
      font-weight: 500;
    }

    .react-dropdown-select-item {
      margin: 2px 4px 2px 0;
      border-radius: 4px;
      padding: 4px 8px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      font-weight: 600;
      font-size: 11px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      white-space: nowrap;
      box-shadow: 0 1px 4px rgba(102, 126, 234, 0.15);
    }
  }

  .react-dropdown-select-dropdown {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    background: #ffffff;
    margin-top: 4px;
    max-height: 350px;
    overflow-y: auto;
    z-index: 1000;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 6px;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .react-dropdown-select-dropdown-item {
    padding: 8px 10px;
    background-color: #f8f9fb;
    border-bottom: 1px solid #f5f5f5;
    transition: all 0.15s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #333;
    font-weight: 500;
    font-size: 12px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 2px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      transform: scaleY(0);
      transition: transform 0.15s ease;
    }

    &:hover {
      background: linear-gradient(135deg, #f0f4ff 0%, #f8f5ff 100%);
      padding-left: 12px;
      color: #667eea;
      font-weight: 600;

      &::before {
        transform: scaleY(1);
      }
    }

    &.selected {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      font-weight: 700;

      &::before {
        display: none;
      }
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .react-dropdown-select-toggle {
    border-radius: 0 4px 4px 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    transition: all 0.2s ease;
    padding: 4px 8px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    &:hover {
      opacity: 0.9;
    }

    &:active {
      opacity: 0.8;
    }
  }
`;

const SortBySelect = styled(CompactStyledSelect)`
  .react-dropdown-select {
    width: 185px;
  }
  .react-dropdown-select-dropdown {
    min-width: 185px;
    white-space: nowrap;
  }
`;

const ViewSeparator = styled.div`
  width: 1px;
  height: 28px;
  background: #ddd;
  margin: 0 4px;
`;

const ViewGroup = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
`;

const ViewButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  border: 1px solid ${props => props.isActive ? '#667eea' : '#ddd'};
  border-radius: 8px;
  background: ${props => props.isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'white'};
  color: ${props => props.isActive ? 'white' : '#667eea'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
    border-color: #667eea;
    background: ${props => props.isActive ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#f5f7fa'};
  }

  svg {
    font-size: 16px;
  }
`;

export default SceneSort;
